(function() {
  'use strict';

  angular.module('eclipseApp.checkout').filter('formatOfferName', [
    '$translate',
    function($translate) {
      var _labels = {};

      $translate('global.label.unlimited').then(
        function(resp) {
          console.log('@formatUsageAllowance ($translate.resp) ', resp);
          _labels.unltd = resp;
        },
        function(err) {
          _labels.unltd = '';
        }
      );

      $translate('global.unit.gb').then(
        function(resp) {
          console.log('@formatUsageAllowance ($translate.resp) ', resp);
          _labels.gb = resp;
        },
        function(err) {
          _labels.gb = '';
        }
      );

      $translate('global.unit.mb').then(
        function(resp) {
          console.log('@formatUsageAllowance ($translate.resp) ', resp);
          _labels.mb = resp;
        },
        function(err) {
          _labels.mb = '';
        }
      );

      return function(input, flag) {
        // var _parsed = input.match(/(\d*\ ?)(GO|GB|Unlimited)/i);
        // var _val = _parsed != null ? _parsed[1] : '';
        // var _unit = _parsed != null ? _parsed[2] : '';
        // console.log('@naa #val', _val, _parsed, _unit);
        // var _return = /\d+/.test(_val) ? '<b>' + (_.isString(_val) ? _val.trim() : _val) + '</b>' + (_.isString(_unit) ? _unit.trim() : _unit) : input;

        var _maybeNull = _.isString(input) ? input.trim() : input;

        var _parsed = _maybeNull && _maybeNull.match(/(\d+)?(\D+)/);
        var _val = _parsed != null ? _parsed[1] : '';
        var _unit = _parsed != null ? _parsed[2] : '';

        var _isUnlimited = !_val && _unit != null && _unit !== '';

        var format_ = function(val, unit) {
          if (val && unit) {
            return (
              val +
              ' ' +
              (_.isString(unit) && _labels[unit.trim()]
                ? _labels[unit.trim()]
                : _.isString(unit)
                ? unit.toUpperCase()
                : unit)
            );
          } else {
            return _.isString(val) ? _labels[val.trim().toLowerCase()] : val;
          }
        };

        if (flag === 'maybeUnlimited') {
          return /\d+/.test(input) && !_unit
            ? input
            : /*UNLTD | 23GB*/
            input != null && /\D+/.test(input) && !/\d+/.test(_val)
            ? format_(input)
            : /*23GB*/
              format_(_val, _unit);
        } else if (flag === 'isUnlimited') {
          return _isUnlimited;
        }
        return input;
      };
    }
  ]);
})();
